import React from 'react';
import {Dialog, DialogBody, DialogFooter, DialogHeader, Text} from '@gravity-ui/uikit';
import {DepositFundsDTO} from '../../../../entities';
import {formatNumberWithSpaces} from '../../../../shared';
import styles from './DepositFundsConfirmModal.module.scss';

interface DepositFundsConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  formData: DepositFundsDTO | null;
  onConfirm: () => void;
  isLoading: boolean;
}

export const DepositFundsConfirmModal = ({
  open,
  setOpen,
  formData,
  onConfirm,
  isLoading,
}: DepositFundsConfirmModalProps) => {
  if (!formData) return null;

  return (
    <Dialog size="s" hasCloseButton open={open} onClose={() => setOpen(false)}>
      <DialogHeader caption="Проверочный экран" />
      <DialogBody>
        <ul className={styles.list}>
          <li className={styles.item}>
            <Text variant="subheader-1">Сумма</Text>
            <Text className={styles.value}>{formatNumberWithSpaces(formData.amount)} ₽</Text>
          </li>

          {formData.reason && (
            <li className={styles.item}>
              <Text variant="subheader-1">Комментарий для бухгалтера</Text>
              <Text className={styles.value}>{formData.reason}</Text>
            </li>
          )}
        </ul>
      </DialogBody>
      <DialogFooter
        onClickButtonCancel={() => setOpen(false)}
        onClickButtonApply={onConfirm}
        propsButtonApply={{
          size: 'l',
          loading: isLoading,
          view: 'action',
        }}
        propsButtonCancel={{size: 'l'}}
        textButtonApply="Внести средства"
        textButtonCancel="Отменить"
      />
    </Dialog>
  );
};
